export default __webpack_public_path__ + "static/media/iq.0a77c7fd.svg";